export const roleData = [
  {
    job: '英雄',
    name: '',
    group: '冒險家',
    class: '劍士',
    skills: '不屈的信念 Lv.6\nHP低於15%時發動效果\n接下來的3秒內每秒恢復MaxHP的35%\n（冷卻210秒）',
    sortType: 13,
    battlefieldEffect: ['STR+10', 'STR+20', 'STR+40', 'STR+80', 'STR+100'],
    doubleFinishingEffect: '36.4(33.1)',
    attackThreshold: '82(97.4)',
    weapon: '雙手斧、劍 (1.44)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '25',
    criticalDamage: '',
  },
  {
    job: '聖騎士',
    name: '',
    group: '冒險家',
    class: '劍士',
    skills: '不屈的信念 Lv.6\nHP低於15%時發動效果\n接下來的3秒內每秒恢復MaxHP的35%\n（冷卻210秒）々',
    sortType: 13,
    battlefieldEffect: ['STR+10', 'STR+20', 'STR+40', 'STR+80', 'STR+100'],
    doubleFinishingEffect: '28.2(25.6)',
    attackThreshold: '126.8(146.7)',
    weapon: '雙手棍、劍 (1.34)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '47',
    criticalDamage: '',
  },
  {
    job: '黑騎士',
    name: '',
    group: '冒險家',
    class: '劍士',
    skills: '不屈的信念 Lv.6\nHP低於15%時發動效果\n接下來的3秒內每秒恢復MaxHP的35%\n（冷卻210秒）々',
    sortType: 8,
    battlefieldEffect: ['MaxHP+2%', 'MaxHP+3%', 'MaxHP+4%', 'MaxHP+5%', 'MaxHP+6%'],
    doubleFinishingEffect: '26.7(24.2)',
    attackThreshold: '138(159)',
    weapon: '槍 (1.49)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '75',
    criticalDamage: '',
  },
  {
    job: '火、毒',
    name: '',
    group: '冒險家',
    class: '法師',
    skills: '實戰的知識 Lv.6\n25%機率對攻擊中HP最高的怪物觸發\n每層增加總傷3%、無視3%。\n可疊加三層，持續10秒。',
    sortType: 8,
    battlefieldEffect: ['MaxMP+2%', 'MaxMP+3%', 'MaxMP+4%', 'MaxMP+5%', 'MaxMP+6%'],
    doubleFinishingEffect: '28.6(26.0)',
    attackThreshold: '124(143.6)',
    weapon: '長、短杖 (1.2)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '35',
    criticalDamage: '',
  },
  {
    job: '冰、雷',
    name: '',
    group: '冒險家',
    class: '法師',
    skills: '實戰的知識 Lv.6\n25%機率對攻擊中HP最高的怪物觸發\n每層增加總傷3%、無視3%。\n可疊加三層，持續10秒。々',
    sortType: 14,
    battlefieldEffect: ['INT+10', 'INT+20', 'INT+40', 'INT+80', 'INT+100'],
    doubleFinishingEffect: '28.6(26)',
    attackThreshold: '124(143.6)',
    weapon: '長、短杖 (1.2)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '35',
    criticalDamage: '',
  },
  {
    job: '主教',
    name: '',
    group: '冒險家',
    class: '法師',
    skills: '實戰的知識 Lv.6\n25%機率對攻擊中HP最高的怪物觸發\n每層增加總傷3%、無視3%。\n可疊加三層，持續10秒。々',
    sortType: 14,
    battlefieldEffect: ['INT+10', 'INT+20', 'INT+40', 'INT+80', 'INT+100'],
    doubleFinishingEffect: '28(25.4)',
    attackThreshold: '128.2(148.2)',
    weapon: '長、短杖 (1.2)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '75',
    criticalDamage: '',
  },
  {
    job: '箭神',
    name: '',
    group: '冒險家',
    class: '弓箭手',
    skills: '探險家的好奇心 Lv.6\n爆率+10%\n怪物收藏登錄率+35%',
    sortType: 16,
    battlefieldEffect: ['DEX+10', 'DEX+20', 'DEX+40', 'DEX+80', 'DEX+100'],
    doubleFinishingEffect: '27.1(24.7)',
    attackThreshold: '134.4(155.1)',
    weapon: '弓 (1.3)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '69',
    criticalDamage: '',
  },
  {
    job: '神射手',
    name: '',
    group: '冒險家',
    class: '弓箭手',
    skills: '探險家的好奇心 Lv.6\n爆率+10%\n怪物收藏登錄率+35%々',
    sortType: 7,
    battlefieldEffect: ['爆率+1%', '爆率+2%', '爆率+3%', '爆率+4%', '爆率+5%'],
    doubleFinishingEffect: '24.4(22.2)',
    attackThreshold: '157.5(180.5)',
    weapon: '弩 (1.35)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '69',
    criticalDamage: '',
  },
  {
    job: '開拓者',
    name: '',
    group: '冒險家',
    class: '弓箭手',
    skills: '探險家的好奇心 Lv.6\n爆率+10%\n怪物收藏登錄率+35%々',
    sortType: 16,
    battlefieldEffect: ['DEX+10', 'DEX+20', 'DEX+40', 'DEX+80', 'DEX+100'],
    doubleFinishingEffect: '30.3(27.5)',
    attackThreshold: '112.8(131.3)',
    weapon: '古代弓 (1.3)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '79',
    criticalDamage: '',
  },
  {
    job: '夜使者',
    name: '',
    group: '冒險家',
    class: '盜賊',
    skills: '小偷的狡詐 Lv.6\n對怪物造成異常狀態\n10秒內增加18%總傷\n（冷卻20秒）',
    sortType: 7,
    battlefieldEffect: ['爆率+1%', '爆率+2%', '爆率+3%', '爆率+4%', '爆率+5%'],
    doubleFinishingEffect: '28.1(25.5)',
    attackThreshold: '127.5(147.5)',
    weapon: '拳套 (1.75)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '75',
    criticalDamage: '',
  },
  {
    job: '暗影神偷',
    name: '',
    group: '冒險家',
    class: '盜賊',
    skills: '小偷的狡詐 Lv.6\n對怪物造成異常狀態\n10秒內增加18%總傷\n（冷卻20秒）々',
    sortType: 15,
    battlefieldEffect: ['LUK+10', 'LUK+20', 'LUK+40', 'LUK+80', 'LUK+100'],
    doubleFinishingEffect: '25.3(23)',
    attackThreshold: '149.4(171.5)',
    weapon: '短刀 (1.3)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '55',
    criticalDamage: '',
  },
  {
    job: '影武者',
    name: '',
    group: '冒險家',
    class: '盜賊',
    skills: '小偷的狡詐 Lv.6\n對怪物造成異常狀態\n10秒內增加18%總傷\n（冷卻20秒）々',
    sortType: 15,
    battlefieldEffect: ['LUK+10', 'LUK+20', 'LUK+40', 'LUK+80', 'LUK+100'],
    doubleFinishingEffect: '28.9(26.2)',
    attackThreshold: '122.1(141.5)',
    weapon: '短刀 (1.3)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '40',
    criticalDamage: '',
  },
  {
    job: '拳霸',
    name: '',
    group: '冒險家',
    class: '海盜',
    skills: '海盜的祝福 Lv.6\n全屬性+70\nMaxHP/MP+1225\n受擊傷害-15%（不含%傷）',
    sortType: 13,
    battlefieldEffect: ['STR+10', 'STR+20', 'STR+40', 'STR+80', 'STR+100'],
    doubleFinishingEffect: '32.2(29.3)',
    attackThreshold: '102(119.4)',
    weapon: '指虎 (1.7)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '40*',
    criticalDamage: '',
  },
  {
    job: '槍神',
    name: '',
    group: '冒險家',
    class: '海盜',
    skills: '海盜的祝福 Lv.6\n全屬性+70\nMaxHP/MP+1225\n受擊傷害-15%（不含%傷）々',
    sortType: 2,
    battlefieldEffect: ['召喚時間+4%', '召喚時間+6%', '召喚時間+8%', '召喚時間+10%', '召喚時間+12%'],
    doubleFinishingEffect: '30.9(28.1)',
    attackThreshold: '109.4(127.6)',
    weapon: '火槍 (1.5)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '75',
    criticalDamage: '',
  },
  {
    job: '重砲指揮官',
    name: '',
    group: '冒險家',
    class: '海盜',
    skills: '海盜的祝福 Lv.6\n全屬性+70\nMaxHP/MP+1225\n受擊傷害-15%（不含%傷）々',
    sortType: 13,
    battlefieldEffect: ['STR+10', 'STR+20', 'STR+40', 'STR+80', 'STR+100'],
    doubleFinishingEffect: '25.4(23.1)',
    attackThreshold: '148.7(170.8)',
    weapon: '加農砲 (1.5)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '45',
    criticalDamage: '',
  },
  {
    job: '精靈遊俠',
    name: 'Mercedes(瑪希蒂絲)',
    group: '英雄團',
    class: '弓箭手',
    skills: '精靈的祝福 Lv.2\n經驗值+15%',
    sortType: 2,
    battlefieldEffect: ['技能冷卻+-2%', '技能冷卻+-3%', '技能冷卻+-4%', '技能冷卻+-5%', '技能冷卻+-6%'],
    doubleFinishingEffect: '25.4(23.1)',
    attackThreshold: '148.5(170.6)',
    weapon: '雙弩槍 (1.3)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '60',
    criticalDamage: '',
  },
  {
    job: '狂狼勇士',
    name: 'Aran(亞蘭)',
    group: '英雄團',
    class: '劍士',
    skills: '連續擊殺優勢 Lv.2\n連續擊殺之珠永久經驗值獲得量增加650%',
    sortType: 10,
    battlefieldEffect: ['打擊敵人時，以70%的機率回復HP+2%', '打擊敵人時，以70%的機率回復HP+4%', '打擊敵人時，以70%的機率回復HP+6%', '打擊敵人時，以70%的機率回復HP+8%', '打擊敵人時，以70%的機率回復HP+10%'],
    doubleFinishingEffect: '30.1(27.3)',
    attackThreshold: '114.3(133)',
    weapon: '矛 (1.49)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '55',
    criticalDamage: '',
  },
  {
    job: '幻影俠盜',
    name: 'Phantom(佩特)',
    group: '英雄團',
    class: '盜賊',
    skills: '致命本能 Lv.2\n爆率+15%',
    sortType: 1,
    battlefieldEffect: ['金幣獲得+1%', '金幣獲得+2%', '金幣獲得+3%', '金幣獲得+4%', '金幣獲得+5%'],
    doubleFinishingEffect: '23.3(21.2)',
    attackThreshold: '168.2(192.3)',
    weapon: '手杖 (1.3)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '55',
    criticalDamage: '',
  },
  {
    job: '夜光',
    name: 'Luminous(露米諾斯)',
    group: '英雄團',
    class: '法師',
    skills: '滲透 Lv.2\n無視防禦+15%',
    sortType: 14,
    battlefieldEffect: ['INT+10', 'INT+20', 'INT+40', 'INT+80', 'INT+100'],
    doubleFinishingEffect: '20.4(18.6)',
    attackThreshold: '202.4(229.8)',
    weapon: '閃亮克魯 (1.2)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '40',
    criticalDamage: '',
  },
  {
    job: '龍魔導士',
    name: 'Evan(伊凡)',
    group: '英雄團',
    class: '法師',
    skills: '輪之堅持 Lv.2\n地圖輪持續時間+50%',
    sortType: 10,
    battlefieldEffect: ['打擊敵人時，以70%的機率回復MP+2%', '打擊敵人時，以70%的機率回復MP+4%', '打擊敵人時，以70%的機率回復MP+6%', '打擊敵人時，以70%的機率回復MP+8%', '打擊敵人時，以70%的機率回復MP+10%'],
    doubleFinishingEffect: '34.2(31.1)',
    attackThreshold: '91.8(108.2)',
    weapon: '長、短杖 (1.2)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '50',
    criticalDamage: '',
  },
  {
    job: '隱月',
    name: 'Shade/Eunwol(隱月)',
    group: '英雄團',
    class: '海盜',
    skills: '死裡逃生 Lv.2\n受到致死攻擊時以10%機率擋死',
    sortType: 6,
    battlefieldEffect: ['爆傷+1%', '爆傷+2%', '爆傷+3%', '爆傷+5%', '爆傷+6%'],
    doubleFinishingEffect: '27.3(24.8)',
    attackThreshold: '133.4(154)',
    weapon: '指虎 (1.7)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '30',
    criticalDamage: '',
  },
  {
    job: '米哈逸',
    name: '',
    group: '皇家騎士團長',
    class: '劍士',
    skills: '光之守護 Lv.2\n15秒內異常+100\n（冷卻120秒）',
    sortType: 9,
    battlefieldEffect: ['MaxHP+250', 'MaxHP+500', 'MaxHP+1000', 'MaxHP+2000', 'MaxHP+2500'],
    doubleFinishingEffect: '21.3(19.4)',
    attackThreshold: '190.5(216.8)',
    weapon: '單手劍 (1.24)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '40*',
    criticalDamage: '',
  },
  {
    job: '聖魂劍士',
    name: '',
    group: '皇家騎士團',
    class: '劍士',
    skills: '西格諾斯的祝福 Lv.10\n魔／物攻+25、狀態異常耐性+15、所有屬性耐性+15%',
    sortType: 9,
    battlefieldEffect: ['MaxHP+250', 'MaxHP+500', 'MaxHP+1000', 'MaxHP+2000', 'MaxHP+2500'],
    doubleFinishingEffect: '40(36.4)',
    attackThreshold: '68(82)',
    weapon: '雙手劍 (1.34)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '50',
    criticalDamage: '',
  },
  {
    job: '烈焰巫師',
    name: '',
    group: '皇家騎士團',
    class: '法師',
    skills: '西格諾斯的祝福 Lv.10\n魔／物攻+25、狀態異常耐性+15、所有屬性耐性+15%々',
    sortType: 14,
    battlefieldEffect: ['INT+10', 'INT+20', 'INT+40', 'INT+80', 'INT+100'],
    doubleFinishingEffect: '26.7(24.2)',
    attackThreshold: '138(159)',
    weapon: '長、短杖 (1.2)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '34',
    criticalDamage: '',
  },
  {
    job: '破風使者',
    name: '',
    group: '皇家騎士團',
    class: '弓箭手',
    skills: '西格諾斯的祝福 Lv.10\n魔／物攻+25、狀態異常耐性+15、所有屬性耐性+15%々',
    sortType: 16,
    battlefieldEffect: ['DEX+10', 'DEX+20', 'DEX+40', 'DEX+80', 'DEX+100'],
    doubleFinishingEffect: '24.7(22.5)',
    attackThreshold: '154.6(177.3)',
    weapon: '弓 (1.3)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '60',
    criticalDamage: '',
  },
  {
    job: '暗夜行者',
    name: '',
    group: '皇家騎士團',
    class: '盜賊',
    skills: '西格諾斯的祝福 Lv.10\n魔／物攻+25、狀態異常耐性+15、所有屬性耐性+15%々',
    sortType: 15,
    battlefieldEffect: ['LUK+10', 'LUK+20', 'LUK+40', 'LUK+80', 'LUK+100'],
    doubleFinishingEffect: '30.9(28.1)',
    attackThreshold: '109.4(127.6)',
    weapon: '拳套 (1.75)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '40',
    criticalDamage: '',
  },
  {
    job: '閃雷悍將',
    name: '',
    group: '皇家騎士團',
    class: '海盜',
    skills: '西格諾斯的祝福 Lv.10\n魔／物攻+25、狀態異常耐性+15、所有屬性耐性+15%々',
    sortType: 13,
    battlefieldEffect: ['STR+10', 'STR+20', 'STR+40', 'STR+80', 'STR+100'],
    doubleFinishingEffect: '33.1(30.1)',
    attackThreshold: '97.1(114)',
    weapon: '指虎 (1.7)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '35',
    criticalDamage: '',
  },
  {
    job: '惡魔殺手',
    name: '',
    group: '末日反抗軍',
    class: '劍士',
    skills: '惡魔之怒 Lv.2\nＢ傷+15%',
    sortType: 11,
    battlefieldEffect: ['狀態異常抵抗增加+1', '狀態異常抵抗增加+2', '狀態異常抵抗增加+3', '狀態異常抵抗增加+4', '狀態異常抵抗增加+5'],
    doubleFinishingEffect: '28(25.4)',
    attackThreshold: '128.2(148.2)',
    weapon: '單手斧(棍) (1.2)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '25*',
    criticalDamage: '',
  },
  {
    job: '惡魔復仇者',
    name: '',
    group: '末日反抗軍',
    class: '劍士',
    skills: '狂暴鬥氣 Lv.2\n總傷+10%',
    sortType: 3,
    battlefieldEffect: ['Ｂ傷+1%', 'Ｂ傷+2%', 'Ｂ傷+3%', 'Ｂ傷+5%', 'Ｂ傷+6%'],
    doubleFinishingEffect: '34.8(31.6)',
    attackThreshold: '89(105.1)',
    weapon: '魔劍 (1.3)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '25',
    criticalDamage: '',
  },
  {
    job: '傑諾',
    name: '',
    group: '末日反抗軍',
    class: '海盜／盜賊',
    skills: '合成邏輯 Lv.2\n全屬性+10%',
    sortType: 12,
    battlefieldEffect: ['STR / DEX / LUK+5', 'STR / DEX / LUK+10', 'STR / DEX / LUK+20', 'STR / DEX / LUK+40', 'STR / DEX / LUK+50'],
    doubleFinishingEffect: '34.8(31.6)',
    attackThreshold: '89(105.1)',
    weapon: '能量劍 (1.3125)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '45',
    criticalDamage: '',
  },
  {
    job: '爆拳槍神',
    name: '',
    group: '末日反抗軍',
    class: '劍士',
    skills: '自由精神 Lv.8\n復活時8秒內無敵',
    sortType: 4,
    battlefieldEffect: ['無視+1%', '無視+2%', '無視+3%', '無視+5%', '無視+6%'],
    doubleFinishingEffect: '38.1(34.6)',
    attackThreshold: '75(89.7)',
    weapon: '重拳槍 (1.7)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '65',
    criticalDamage: '',
  },
  {
    job: '煉獄巫師',
    name: '',
    group: '末日反抗軍',
    class: '法師',
    skills: '自由精神 Lv.8\n復活時8秒內無敵々',
    sortType: 14,
    battlefieldEffect: ['INT+10', 'INT+20', 'INT+40', 'INT+80', 'INT+100'],
    doubleFinishingEffect: '25.2(22.9)',
    attackThreshold: '150(172.2)',
    weapon: '長杖 (1.2)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '60',
    criticalDamage: '',
  },
  {
    job: '狂豹獵人',
    name: '',
    group: '末日反抗軍',
    class: '弓箭手',
    skills: '自由精神 Lv.8\n復活時8秒內無敵々',
    sortType: 5,
    battlefieldEffect: ['攻擊時20%的機率來增加傷害+4%', '攻擊時20%的機率來增加傷害+8%', '攻擊時20%的機率來增加傷害+12%', '攻擊時20%的機率來增加傷害+16%', '攻擊時20%的機率來增加傷害+20%'],
    doubleFinishingEffect: '30.3(27.5)',
    attackThreshold: '112.8(131.3)',
    weapon: '弩 (1.35)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '73',
    criticalDamage: '',
  },
  {
    job: '機甲戰神',
    name: '',
    group: '末日反抗軍',
    class: '海盜',
    skills: '自由精神 Lv.8\n復活時8秒內無敵々',
    sortType: 2,
    battlefieldEffect: ['加持有效時間增加+5%', '加持有效時間增加+10%', '加持有效時間增加+15%', '加持有效時間增加+20%', '加持有效時間增加+25%'],
    doubleFinishingEffect: '28.2(25.6)',
    attackThreshold: '126.8(146.7)',
    weapon: '火槍 (1.5)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '35/65*',
    criticalDamage: '',
  },
  {
    job: '神之子',
    name: 'Zero(優伊娜之子)',
    group: '超越者',
    class: '劍士',
    skills: '時之祝福 Lv.5（角色178等）\n無視防禦+10%、受擊傷害-15%（不含%傷）',
    sortType: 0,
    battlefieldEffect: ['經驗獲得+4%', '經驗獲得+6%', '經驗獲得+8%', '經驗獲得+10%', '經驗獲得+12%'],
    doubleFinishingEffect: '26(23.7)',
    attackThreshold: '143.3(164.8)',
    weapon: '璃+琉 (1.34+1.49)',
    attackSpeed: '7β/8α',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '55',
    criticalDamage: '',
  },
  {
    job: '凱內西斯',
    name: 'Kinesis(凱內西斯)',
    group: '朋友世界',
    class: '法師',
    skills: '判斷 Lv.2\n爆傷+4%',
    sortType: 14,
    battlefieldEffect: ['INT+10', 'INT+20', 'INT+40', 'INT+80', 'INT+100'],
    doubleFinishingEffect: '23.8(21.6)',
    attackThreshold: '163.2(186.7)',
    weapon: 'ESP限制器 (1.2)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '45',
    criticalDamage: '',
  },
  {
    job: '凱撒',
    name: 'Kaiser(凱撒)',
    group: '超新星',
    class: '劍士',
    skills: '鋼鐵意志 Lv.2\nHP+15%',
    sortType: 13,
    battlefieldEffect: ['STR+10', 'STR+20', 'STR+40', 'STR+80', 'STR+100'],
    doubleFinishingEffect: '30.3(27.5)',
    attackThreshold: '112.8(131.3)',
    weapon: '雙手劍 (1.34)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '65',
    criticalDamage: '',
  },
  {
    job: '凱殷',
    name: 'Kain(凱殷)',
    group: '超新星',
    class: '弓箭手',
    skills: '事前準備 Lv.2\n打倒8名敵人或攻擊BOSS第5次時，可以做1次準備，完成5次準備後增加17%總傷20秒。\n（冷卻40秒）',
    sortType: 16,
    battlefieldEffect: ['DEX+10', 'DEX+20', 'DEX+40', 'DEX+80', 'DEX+100'],
    doubleFinishingEffect: '19.9(18)',
    attackThreshold: '210.1(238.3)',
    weapon: '龍息射手 (1.3)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '60',
    criticalDamage: '',
  },
  {
    job: '卡蒂娜',
    name: 'Cadena(卡蒂娜)',
    group: '超新星',
    class: '盜賊',
    skills: '集中狂擊 Lv.2\n攻擊比角色等級低的怪物時總傷+6%\n攻擊狀態異常的怪物時總傷+6%',
    sortType: 15,
    battlefieldEffect: ['LUK+10', 'LUK+20', 'LUK+40', 'LUK+80', 'LUK+100'],
    doubleFinishingEffect: '40(36.4)',
    attackThreshold: '68(82)',
    weapon: '鎖鍊 (1.3)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '55*',
    criticalDamage: '',
  },
  {
    job: '天使破壞者',
    name: 'Tear(提爾)',
    group: '超新星',
    class: '海盜',
    skills: '靈魂契約 Lv.2\n10秒內總傷增加45%\n（冷卻60秒）',
    sortType: 16,
    battlefieldEffect: ['DEX+10', 'DEX+20', 'DEX+40', 'DEX+80', 'DEX+100'],
    doubleFinishingEffect: '25.1(22.8)',
    attackThreshold: '151(173.4)',
    weapon: '靈魂射手 (1.7)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '35',
    criticalDamage: '',
  },
  {
    job: '阿戴爾',
    name: 'Adelaide(阿戴萊德)',
    group: '雷普',
    class: '劍士',
    skills: '貴族 Lv.2\nＢ傷+4%\n組隊成員在同一張圖時，包含自己在內的每位隊員增加2%總傷，未組隊情況以2%計算。（上限8%）',
    sortType: 13,
    battlefieldEffect: ['STR+10', 'STR+20', 'STR+40', 'STR+80', 'STR+100'],
    doubleFinishingEffect: '26.3(23.9)',
    attackThreshold: '140.9(162.2)',
    weapon: '調節器 (1.3)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '45',
    criticalDamage: '',
  },
  {
    job: '伊利恩',
    name: 'Illium(伊利恩)',
    group: '雷普',
    class: '法師',
    skills: '戰鬥的流動 Lv.2\n移動一段距離後增加2%總傷\n可疊加6次，持續10秒。',
    sortType: 14,
    battlefieldEffect: ['INT+10', 'INT+20', 'INT+40', 'INT+80', 'INT+100'],
    doubleFinishingEffect: '27.2(24.7)',
    attackThreshold: '133.8(154.4)',
    weapon: '魔法護腕 (1.2)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '45',
    criticalDamage: '',
  },
  {
    job: '卡莉',
    name: 'Khali(卡莉)',
    group: '雷普',
    class: '盜賊',
    skills: '天賦 Lv.2\n總傷+5%\n攻擊時恢復HP/MP 2%，持續5秒。（冷卻30秒）',
    sortType: 15,
    battlefieldEffect: ['LUK+10', 'LUK+20', 'LUK+40', 'LUK+80', 'LUK+100'],
    doubleFinishingEffect: '22(20)',
    attackThreshold: '182.8(208.3)',
    weapon: '環刃 (1.3)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '40',
    criticalDamage: '',
  },
  {
    job: '亞克',
    name: 'Ark(亞克)',
    group: '雷普',
    class: '海盜',
    skills: '無我 Lv.2\n戰鬥狀態持續每5秒發動一次，可疊加5次。\n發動時總傷+1%，疊加一次總傷+2%。（疊滿+11%）',
    sortType: 13,
    battlefieldEffect: ['STR+10', 'STR+20', 'STR+40', 'STR+80', 'STR+100'],
    doubleFinishingEffect: '28.3(25.8)',
    attackThreshold: '125.6(145.3)',
    weapon: '指虎 (1.7)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '55',
    criticalDamage: '',
  },
  {
    job: '蓮',
    name: 'Len(蓮)',
    group: '阿尼瑪',
    class: '劍士',
    skills: '護體 Lv.2\n受擊傷害-4%（含%傷）',
    sortType: 14,
    battlefieldEffect: ['移速+2', '移速+4', '移速+6', '移速+8', '移速+10'],
    doubleFinishingEffect: '()',
    attackThreshold: '()',
    weapon: '長劍 (1.3)',
    attackSpeed: '8',
    bossDamage: '0',
    ignoreDefense: '40',
    criticalChance: '50',
    criticalDamage: '10',
  },
  {
    job: '菈菈',
    name: 'Lara(菈菈)',
    group: '阿尼瑪',
    class: '法師',
    skills: '大自然夥伴 Lv.2\n總傷+5%\n擊殺20隻一般怪物後，30秒內對一般怪物攻擊傷害+11%。\n（冷卻30秒）',
    sortType: 14,
    battlefieldEffect: ['INT+10', 'INT+20', 'INT+40', 'INT+80', 'INT+100'],
    doubleFinishingEffect: '21.2(19.3)',
    attackThreshold: '191.9(218.3)',
    weapon: '短杖 (1.2)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '45',
    criticalDamage: '',
  },
  {
    job: '虎影',
    name: 'HoYoung(虎影)',
    group: '阿尼瑪',
    class: '盜賊',
    skills: '自信心 Lv.2\n無視防禦+10%\n對滿血怪物的第一下攻擊+14%總傷',
    sortType: 15,
    battlefieldEffect: ['LUK+10', 'LUK+20', 'LUK+40', 'LUK+80', 'LUK+100'],
    doubleFinishingEffect: '22.4(20.4)',
    attackThreshold: '178.1(203.1)',
    weapon: '仙扇 (1.3)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '55',
    criticalDamage: '',
  },
  {
    job: '劍豪',
    name: 'Hayato(劍斗)',
    group: '曉之陣',
    class: '劍士',
    skills: '蒼刃傳授 Lv.2\n爆傷+5%',
    sortType: 6,
    battlefieldEffect: ['爆傷+1%', '爆傷+2%', '爆傷+3%', '爆傷+5%', '爆傷+6%'],
    doubleFinishingEffect: '40(36.4)',
    attackThreshold: '68(82)',
    weapon: '太刀 (1.25)',
    attackSpeed: '7/8*',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '50/100*',
    criticalDamage: '',
  },
  {  // https://maplestory.nexon.co.jp/job/akatsuki/kanna/
    job: '陰陽師',
    CV: ['水中雅章', 'MoeMi', '加藤英美里/小松未可子', 'Lynn', '佐々木未来', '稲垣好'],
    name: 'Kanna(神那)',
    group: '曉之陣',
    class: '法師',
    skills: '紫扇傳授 Lv.2\n每攻擊40次則總傷害+15%，持續12秒。',
    sortType: 3,
    battlefieldEffect: ['Ｂ傷+1%', 'Ｂ傷+2%', 'Ｂ傷+3%', 'Ｂ傷+5%', 'Ｂ傷+6%'],
    doubleFinishingEffect: '33.3(30.3)',
    attackThreshold: '96(112.8)',
    weapon: '扇子 (1.35)',
    attackSpeed: '6',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '30',
    criticalDamage: '',
  },
  /*{
    job: '幻獸師',
    name: 'Chase(柴絲)',
    group: '登貝伊',
    class: '法師',
    skills: '精靈集中 Lv.2\nＢ傷+7%、爆率+7%、HP/MP+4%',
    sortType: 4,
    battlefieldEffect: ['無視+1%', '無視+2%', '無視+3%', '無視+5%', '無視+6%'],
    doubleFinishingEffect: '40(36.4), 33.3(30.3)',
    attackThreshold: '68(82), 96(112.8)',
    weapon: '幻獸棍棒 (1.34)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '88(熊)',
    criticalDamage: '',
  },*/
  {
    job: '墨玄',
    name: 'MoXuan(墨玄)',
    group: '江湖',
    class: '海盜',
    skills: '氣魄 Lv.2\n攻擊BOSS怪物時Ｂ傷+4%。\n 攻擊BOSS成功時額外+2%Ｂ傷，最多可以疊6層，疊加於每2秒發動一次，持續5秒。（疊滿+16%）',
    sortType: 6,
    battlefieldEffect: ['爆傷+1%', '爆傷+2%', '爆傷+3%', '爆傷+5%', '爆傷+6%'],
    doubleFinishingEffect: '33.1(30.1)',
    attackThreshold: '97.4(114.3)',
    weapon: '武拳 (1.75)',
    attackSpeed: '8',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '55',
    criticalDamage: '',
  },
  {
    job: '琳恩',
    name: 'Lynn(琳恩)',
    group: '江湖',
    class: '法師',
    skills: '守護神的保佑 Lv.2\nＢ傷+7%、爆率+7%、MaxHP/MP+4%',
    sortType: 4,
    battlefieldEffect: ['無視+1%', '無視+2%', '無視+3%', '無視+5%', '無視+6%'],
    doubleFinishingEffect: '25(22.7)',
    attackThreshold: '152(174.4)',
    weapon: '記憶長杖 (1.34)',
    attackSpeed: '7',
    bossDamage: '',
    ignoreDefense: '',
    criticalChance: '82',
    criticalDamage: '',
  },
];
